<script lang="ts">
  import { browser } from "$app/environment";
  import { goto } from "$app/navigation";
  import { page } from "$app/stores";
  import { klaviyoIdentify } from "$lib/klaviyo";
  import { checkLoginStatus, isLoggedIn } from "$lib/store/auth-context";
  import { closeModal } from "@thehood/svlib";
  import { onDestroy, onMount } from "svelte";
  export let step: number;
  export let blockClose: boolean;
  export let error: string = "";

  function backToLogin() {
    step = 1;
  }

  let id!: NodeJS.Timeout;
  function pollStatus() {
    clearInterval(id);
    id = setInterval(
      () =>
        checkLoginStatus().then(respData => {
          const { status, email } = respData;
          if (!status) {
            return;
          }
          isLoggedIn.update(() => true);
          browser && email && klaviyoIdentify(email);
          // location.reload();
          goto($page.url.pathname);
          blockClose = false;
          closeModal();
          clearInterval(id);
        }),
      2000
    );
  }

  onMount(pollStatus);
  onDestroy(() => clearInterval(id));
</script>

<!--
  Button back
<div>
  <slot />
</div> -->

<div class="wrapper">
  {#if error}
    <h2 class="danger">{error}</h2>
  {:else}
    <i />
    <h2 class="sf-900">Please check your emails</h2>
    <p class="sf-300">
      We’ve send a verification link to <br />your e-mail address. Please click the link in the e-mail to continue.
    </p>
    <div class="actions">
      <button type="button" on:click={backToLogin} class="pf-700">Back</button>
    </div>
  {/if}
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .wrapper {
    position: relative;
    text-align: center;
    display: flex;
    flex-direction: column;
    @include desktop {
      max-height: 37.5em;
    }
    h2 {
      font-size: 1.875em;
      margin: 1em 0;
      line-height: 120%;
      text-transform: uppercase;
    }
    i {
      align-self: center;
      height: 9.375em;
      background: url("/svg/mail.svg") no-repeat center;
      background-size: contain;
      width: 9.375em;
      height: 9.375em;
    }
    .actions {
      margin: 1.25em 0;
    }
  }
</style>
